export const userActionTypes = {
  ON_LOGIN_SUCCESS: "ON_LOGIN_SUCCESS",
  SET_USER: "SET_USER",
  LOGOUT_FROM_APPLICATION: "LOGOUT_FROM_APPLICATION",
  CHANGED_PASSWORD: "CHANGED_PASSWORD",
  SET_USER_ORGANIZATION: "SET_USER_ORGANIZATION",
  SET_CURRENT_WORKING_ORGANIZATION: "SET_CURRENT_WORKING_ORGANIZATION",
  REQUEST_CHANGED_PASSWORD_LINK: "REQUEST_CHANGED_PASSWORD_LINK",
  ON_RECEIVED_TOKEN: "ON_RECEIVED_TOKEN",
  SET_LAST_STEP_COMPLETED: "SET_LAST_STEP_COMPLETED",
  SET_TYPEFORM_RESPONSE_ID: "SET_TYPEFORM_RESPONSE_ID",
  SET_USER_PROFILE: "SET_USER_PROFILE",
};

export default {
  logout: (redirectURL) => ({
    type: userActionTypes.LOGOUT_FROM_APPLICATION,
    redirectURL,
  }),

  onLoginSuccess: (data) => ({
    type: userActionTypes.ON_LOGIN_SUCCESS,
    data,
  }),
  setToken: (data) => ({
    type: userActionTypes.ON_RECEIVED_TOKEN,
    data,
  }),
  setUser: (user) => ({
    type: userActionTypes.SET_USER,
    user,
  }),
  changedPassword: (data, options) => ({
    type: userActionTypes.CHANGED_PASSWORD,
    data,
    options,
  }),
  requestChangePasswordLink: (email, options) => ({
    type: userActionTypes.REQUEST_CHANGED_PASSWORD_LINK,
    email,
    options,
  }),
  setUserOrganizations: (orgs) => ({
    type: userActionTypes.SET_USER_ORGANIZATION,
    orgs,
  }),
  setCurrentWorkingOrg: (currentOrg) => ({
    type: userActionTypes.SET_CURRENT_WORKING_ORGANIZATION,
    currentOrg,
  }),
  setLastStepCompleted: (lastStep) => ({
    type: userActionTypes.SET_LAST_STEP_COMPLETED,
    lastStep,
  }),
  setTypeformResponseId: (typeformResponseId) => ({
    type: userActionTypes.SET_TYPEFORM_RESPONSE_ID,
    typeformResponseId,
  }),
  setUserProfile: (profile) => ({
    type: userActionTypes.SET_USER_PROFILE,
    profile,
  }),
};
